import { BiArrowBack, BiTime } from 'react-icons/bi';

export const DateTimeMenu = ({ contextMenuList, back, onSelect }: { contextMenuList: any[]; back: () => void; onSelect: (context: any) => void }) => {
  return (
    <div className="tw-w-[342px] tw-h-max tw-max-h-[281px] tw-relative tw-z-50">
      <div className="tw-w-[342px] tw-max-h-[272px] tw-py-2 tw-left-0 tw-top-[9px] tw-absolute tw-bg-white tw-rounded-md tw-shadow tw-border tw-border-gray-300 tw-flex-col tw-justify-start tw-items-start tw-gap-1 tw-inline-flex">
        <div
          role="button"
          tabIndex={0}
          className="tw-pt-2 tw-pb-1 tw-justify-center tw-items-center tw-gap-2.5 tw-inline-flex tw-bg-gray-100"
          onClick={back}
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') back();
          }}
        >
          <div className="tw-w-[342px] tw-pl-5 tw-h-5 tw-text-gray-500 tw-text-sm tw-font-normal tw-font-['Lexend'] tw-leading-tight tw-text-left">
            <BiArrowBack className="tw-cursor-pointer tw-h-5 tw-w-5 tw-mr-[5px]" />
            <span>Date Time</span>
          </div>
        </div>
        <div className="tw-self-stretch tw-max-h-[220px] tw-px-2 tw-flex-col tw-justify-start tw-items-start tw-flex tw-overflow-auto">
          {contextMenuList?.map((dr, index) => (
            <button
              id="btn-select-time"
              key={index}
              onClick={() => {
                onSelect(dr);
              }}
              className="tw-cursor-pointer tw-bg-transparent tw-border-none tw-self-stretch tw-px-4 tw-py-2.5 hover:tw-bg-gray-100 tw-rounded tw-justify-start tw-items-center tw-gap-3 tw-inline-flex"
            >
              <BiTime className="tw-w-6 tw-h-6 tw-relative" />
              <div className="tw-w-full tw-text-gray-700 tw-text-base tw-font-normal tw-font-['Lexend'] tw-leading-normal tw-text-start">{dr.name}</div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
